export function measureText(text, className = "chart-axis-label") {
  const container = document.createElement("div");
  container.classList.add(className);
  container.style.position = "absolute";
  container.style.top = "0";
  container.style.visibility = "hidden";
  container.textContent = text;
  document.body.appendChild(container);
  const {
    width,
    height
  } = container.getBoundingClientRect();
  document.body.removeChild(container);
  return {
    width,
    height
  };
}